// source: pbtypes/gen/shape_map/half_plane.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.shape_map.HalfPlanePb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shape_map.HalfPlanePb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.shape_map.HalfPlanePb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shape_map.HalfPlanePb.displayName = 'proto.shape_map.HalfPlanePb';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shape_map.HalfPlanePb.prototype.toObject = function(opt_includeInstance) {
  return proto.shape_map.HalfPlanePb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shape_map.HalfPlanePb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.HalfPlanePb.toObject = function(includeInstance, msg) {
  var f, obj = {
add: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
point: (f = msg.getPoint()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
planeUnitNormal: (f = msg.getPlaneUnitNormal()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shape_map.HalfPlanePb}
 */
proto.shape_map.HalfPlanePb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shape_map.HalfPlanePb;
  return proto.shape_map.HalfPlanePb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shape_map.HalfPlanePb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shape_map.HalfPlanePb}
 */
proto.shape_map.HalfPlanePb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdd(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setPoint(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setPlaneUnitNormal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shape_map.HalfPlanePb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shape_map.HalfPlanePb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shape_map.HalfPlanePb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.HalfPlanePb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdd();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPoint();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getPlaneUnitNormal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool add = 1;
 * @return {boolean}
 */
proto.shape_map.HalfPlanePb.prototype.getAdd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shape_map.HalfPlanePb} returns this
 */
proto.shape_map.HalfPlanePb.prototype.setAdd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector3dPb point = 2;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.shape_map.HalfPlanePb.prototype.getPoint = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.shape_map.HalfPlanePb} returns this
*/
proto.shape_map.HalfPlanePb.prototype.setPoint = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shape_map.HalfPlanePb} returns this
 */
proto.shape_map.HalfPlanePb.prototype.clearPoint = function() {
  return this.setPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shape_map.HalfPlanePb.prototype.hasPoint = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional eigen_lcm.Vector3dPb plane_unit_normal = 3;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.shape_map.HalfPlanePb.prototype.getPlaneUnitNormal = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.shape_map.HalfPlanePb} returns this
*/
proto.shape_map.HalfPlanePb.prototype.setPlaneUnitNormal = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.shape_map.HalfPlanePb} returns this
 */
proto.shape_map.HalfPlanePb.prototype.clearPlaneUnitNormal = function() {
  return this.setPlaneUnitNormal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.shape_map.HalfPlanePb.prototype.hasPlaneUnitNormal = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.shape_map);
